import React, { useState } from "react";
import EditionView from "./EditionView";
import { EditionGroupRecord, ActiveIndex, emptyActiveIndex } from "../Types";
import { Dimensions } from "../Dimensions";
import VisibilitySensor from "react-visibility-sensor";

interface EditionGroupProps {
    group: EditionGroupRecord;
    activeIndex: ActiveIndex;
    groupIndex: number;
    setActiveIndex: (activeIndex: ActiveIndex) => void;
    dimensions: Dimensions;
    // setActiveIndex: (editionIndex: number, printIndex: number) => void
}

/**
 * A grouping of editions (such as all editions from a certain year, or all copies of a certain book)
 */
export const EditionGroupView = React.memo(function InnerEditionGroupView(props: EditionGroupProps) {

    const [visible, setVisible] = useState<boolean>(false);

    const paletteWidth = 10,
        padding = 2;

    return (
        <VisibilitySensor
            partialVisibility={true}
            onChange={
                (isVisible: boolean) => {
                    setVisible(isVisible);
                }
            }
        >

            <div className="EditionGroup">
                <h3>{props.group.title}</h3>
                <div style={{
                    display: "flex",
                    flexWrap: "wrap"
                }}>
                    {props.group.editions.map((ed, i) => {

                        return (
                            <EditionView
                                groupVisible={visible}
                                displayYear={false}
                                dimensions={props.dimensions}
                                paletteWidth={paletteWidth}
                                padding={padding}
                                editionIndex={i}
                                groupIndex={props.groupIndex}
                                activeIndex={props.activeIndex.editionIndex === i ? props.activeIndex : emptyActiveIndex}
                                setActiveIndex={props.setActiveIndex}
                                // activeEdition={props.activeEdition}
                                // setActiveEdition={props.setActiveEdition}
                                // dx={props.dx} 
                                key={`ed-group-${i.toString()}`}
                                edition={ed}
                            // bdata={props.bdata}
                            />

                        )
                    })}
                </div>
            </div>
        </VisibilitySensor>

    )
});
